/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")
	.controller( "ImportNeptuneParametersCtrl", ["$scope", function ($scope) {
		$scope.data = {
			description: "",
			cleanMode: "",
			linePrefixToRemove: "",
			ignoreCommercialPoints: false,
			areaCentroidPrefixToRemove: "",
			stopAreaPrefixToRemove: "",
			keepBoardingAlightingPossibility: "false",
			keepStopGeolocalisation: "false",
			keepStopNames: "true",
		};
	}]);